export const COLOR_WHITE = "#FFFFFF";
export const COLOR_BACKGROUND_ONE = "#FAFBFD";
export const COLOR_BACKGROUND_TWO = "#F7F9FD";
export const COLOR_PRIMARY_ONE = "#3954FF";
export const COLOR_PRIMARY_TWO = "#5A5AF3";
export const COLOR_PRIMARY_THREE = "#FFD339";
export const COLOR_PRIMARY_FOUR = "#FF6D39";
export const COLOR_TEXT_PRIMARY = "#1F2127";
